import urlApi from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {
    // ALERT TOAST
    launchToast(icon, msg) {
        Vue.toasted.show(msg, {
            icon: icon,
            position: 'top-right',
            duration: 5000,
            fullWidth: false
        })
    },

    // CARREGAR AUTO ESCOLAS
    async loadCfc() {
        let selectCFC = [
            { value: '', text: 'SELECIONE UMA AUTO ESCOLA' },
        ]

        Vue.http.get(urlApi + '/autoescola').then(response => {
            response.data.dados.map(autoescolas => {
                if (autoescolas.nome_fantasia !== 'TESTE') {
                    selectCFC.push({
                        value: autoescolas.tenant_schema,
                        text: autoescolas.nome_fantasia,
                    })
                }
            })
        })

        return selectCFC;
    },

    // ENVIAR POSTS
    async criarPost(data, callback) {
        Vue.http.post(urlApi + '/alunos/feed/posts/criar', data)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                callback(error)
            })
    },

    // PEGAR POST
    async getPost(id, callback) {
        Vue.http.get(`${urlApi}/alunos/feed/posts/${id}`)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                callback(error)
            })
    },

    // EDITAR POST
    async editPost(id, data, callback) {
        Vue.http.put(`${urlApi}/alunos/feed/posts/editar/${id}`, data)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                callback(error)
            })
    },

    // EXCLUIR POST
    async excluirPost(data, callback) {
        Vue.http.delete(`${urlApi}/alunos/feed/posts/excluir/${data.id}?schema=${data.schema}`)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                callback(error)
            })
    },

    // PEGAR POSTS
    async getPosts(data, callback) {
        Vue.http.get(`${urlApi}/alunos/feed/posts?schema=${data.schema}&periodoI=${data.periodo[0]}&periodoF=${data.periodo[1]}`)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                callback(error)
            })
    }
}